module.exports = __webpack_public_path__ + "media/images/icons/store-b52f703d24e03e380cf7f938e0a89121.svg";